import { use } from "echarts/core"

import { CanvasRenderer } from "echarts/renderers"

import { LineChart, BarChart, PieChart } from "echarts/charts"

import {
  GridComponent,
  LegendComponent,
  TitleComponent,
  TooltipComponent,
} from "echarts/components"

use([
  CanvasRenderer,
  LineChart,
  BarChart,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent,
])

export type { EChartsOption } from "echarts"
export type { LineSeriesOption, BarSeriesOption, PieSeriesOption } from "echarts/charts"
export type {
  GridComponentOption,
  LegendComponentOption,
  TitleComponentOption,
  TooltipComponentOption,
} from "echarts/components"
